import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'phone',
})
export class PhonePipe implements PipeTransform {
  transform(rawNum: string) {
    const areaCodeStr = rawNum.slice(0, 3);
    const midSectionStr = rawNum.slice(3, 6);
    const lastSectionStr = rawNum.slice(6, 10);
    return `+1(${areaCodeStr}) ${midSectionStr}-${lastSectionStr}`;
  }
}
